const transformCategory = ( data ) => ({
    id: data.id_facility_type,
    type: data.id_facility_type,
    name: {
        es: data.name_es,
        eu: data.name_eu,
    },
})

export default transformCategory;